import NoImage from '@/components/customercenter-ui/svgs/noImage';
import ContentStackImage from '../../../../../common/contentStackImage/contentStackImage';
import { Swatch } from '../../types';

export const SwatchThumbnail = ({
  swatch,
  isSelected,
  onSwatchSelect,
}: {
  swatch: Swatch;
  isSelected: boolean;
  onSwatchSelect: (swatch: Swatch) => void;
}) => {
  return (
    <div
      aria-hidden="true"
      key={swatch.id}
      onClick={() => onSwatchSelect(swatch)}
      className={`h-9 w-9  cursor-pointer rounded-full border ${
        isSelected ? 'border-2 border-black' : 'border-foggyGray'
      }`}
      style={{ backgroundColor: swatch.color }}
    >
      {swatch?.mainImageURL ? (
        <ContentStackImage
          className={'rounded-full pt-[2px]'}
          src={swatch?.mainImageURL}
          imageWidth={32}
          imageHeight={32}
          alt={swatch.key as string}
          loading="eager"
        />
      ) : (
        <NoImage className={'rounded-full'} width={32} height={32} />
      )}
    </div>
  );
};
